var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ph-icon",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 256 256","aria-hidden":"true","focusable":"false"},domProps:{"innerHTML":_vm._s(_vm.icons[_vm.name])}})
}
var staticRenderFns = []

export { render, staticRenderFns }